export type TruncateMiddleOptions = { separator?: string } & (
  | { length: number; headLength?: never; tailLength?: never }
  | { length?: never; headLength: number; tailLength: number }
)

// Keep the head and tail and drop the middle. Useful when signal lives at both
// ends — e.g. error messages with leading context and a trailing root
// cause/status. Pass `length` for an even split, or explicit
// `headLength`/`tailLength` to bias one side.
export function truncateMiddle(
  value: string,
  options: TruncateMiddleOptions
): string {
  const separator = options.separator ?? '…'
  const headLength =
    options.length !== undefined
      ? Math.ceil((options.length - separator.length) / 2)
      : options.headLength
  const tailLength =
    options.length !== undefined
      ? Math.floor((options.length - separator.length) / 2)
      : options.tailLength
  if (value.length <= headLength + tailLength + separator.length) {
    return value
  }
  return (
    value.slice(0, headLength) +
    separator +
    value.slice(value.length - tailLength)
  )
}
